export const DATE_FORMAT = 'dd.MM.yyyy';
export const KEY_DATE_FORMAT = 'DD.MM.YYYY';
export const KEY_ENTER = 13;
